import React from "react"
import { motion } from "framer-motion"
import { randomThemeColor } from "../utils/randomThemeColor"

const LabelImage = ({ height, width, src, squareBackground }) => {
  return (
    <>
      <motion.div
        id={"border"}
        className={"label-image"}
        style={{
          overflow: "show",
          backgroundColor: squareBackground
            ? squareBackground
            : randomThemeColor(),
          border: "2px solid #222",
          position: "relative",
          marginLeft: 20,
          marginRight: 20,
          marginBottom: 100,
          height: height,
          width: width,
        }}
      >
        <motion.div
          id={"TopSquare"}
          className={"label-image"}
          style={{
            backgroundColor: "white",
            border: "2px solid #222",
            height: height,
            width: width,
            position: "absolute",
            wordWrap: "break-word",
            overflow: "hidden",
            top: -15,
            left: 13,
          }}
        >
          <motion.img
            id={"label-image"}
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              marginBottom: 0,
            }}
            src={src}
          />
        </motion.div>
      </motion.div>
    </>
  )
}

LabelImage.defaultProps = {
  height: 550,
  width: 370,
}

export default LabelImage
